module.exports = __webpack_public_path__ + "img/menu_button_playnow_hover_cn.8014de22.png";